<template>
<div class="user-group-course-index action-table">
    <v-client-table
        :data="tableData"
        :columns="columns"
        :options="options"
        ref="table"
    >
        <colored-letter-square slot="cls_column"
            slot-scope="props"
            :name="props.row.title"
            :length="1"
        >
        </colored-letter-square>

        <div slot="actions"
            slot-scope="props"
        >
            <UserGroupCoursesTableActions
                :user-group="userGroup"
                :client="client"
                :data="props.row"
                :index="props.index"
            ></UserGroupCoursesTableActions>
        </div>
    </v-client-table>
</div>
</template>

<script>
import { EventBus } from '../eventbus';
import { Event } from 'vue-tables-2';

export default {
    props: [
        'client',
        'userGroup',
    ],

    data() {
        return {
            tableData: [],
            columns: ['cls_column', 'title', 'actions'],
            options: {
                headings: {
                    cls_column: '',
                    title: this.trans('courses.label.title'),
                    actions: this.trans('vuetables.label.actions')
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search')
                },

                sortable: ['title'],
            }
        };
    },

    created() {
        this.fetch();
    },

    methods: {
        fetch() {
            axios.get(this.route('tenantapi.clients.user-groups.courses.index', {'client': this.client.id, 'user_group': this.userGroup.id}))
                 .then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },

        /**
         * Deletes the given user
         */
        delete(row, index) {
            this.$alertify.confirmWithTitle(
                this.trans('user_groups.note.unassign_course_title'),
                this.trans('user_groups.note.unassign_course_message'),
                () => {
                    axios
                        .delete(this.route('tenantapi.clients.user-groups.courses.destroy', {'client': this.client.id, 'user_group': this.userGroup.id, 'course': row.id}))
                        .then(response => {
                            this.tableData.splice(index - 1, 1);
                            this.flash(response);
                        })
                        .catch(error => {
                            this.flash({
                                message: this.trans('user_groups.flash.not_unassigned'),
                                level: 'warning'
                            });
                        });
                }
            );
        },
    },

    mounted() {
        EventBus.$on('onDelete', (deleteId) => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        var filter = this.debounce((query) => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
    },
};
</script>
